import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ApproveVendorAction,
  BlackListVendor,
  DeclineVendorAction,
  GetSingleVendor,
  SuspendVendorAction,
} from "../../../../../utils/redux/Vendor/VendorSlice";
import { useNavigate, useParams } from "react-router";
import { PageActions } from "../../../Components/Misc/Actions";
import { useApprovals } from "../VendorApprovals/useApprovals";
import SetUpVendor from "./SetUpVendors";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { usePermissions } from "../../../../../utils/functions/GetMyPermissions";
import { toast } from "react-toastify";

// const Authorized_Actions = ["Approve Account", "Decline Account"];

export const STATUS = {
  APPROVED: "Approved",
  DECLINED: "Declined",
  SUSPENDED: "Suspended",
  BLACKLISTED: "Blacklist",
  INITIATED: "Initiated",
  PROCESSING: "Pending",
  CANCELLED: "Canceled",
  AUTHORIZER1: "Authorizer1",
  AUTHORIZER2: "Authorizer2",
  AUTHORIZER3: "Authorizer3",
};

// const APPROVAL_PERSONS = {
//   PVM: "PVM",
//   SVM: "SVM",
// };

export const findState = (data) => {
  const stat = (search) => {
    if (search.includes(data)) {
      return true;
    }
    return false;
  };

  return { stat };
};

function ViewVendorOperations(props) {
  // const [displayStatus, setDisplayStatus] = useState(true);
  const { staffId } = GetLocalStorage();

  const { userPermissions } = usePermissions();
  // const isSVM = userPermissions.includes(
  //   DEFINED_PERMISSIONS.SeniorVendorManager
  // );
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { isLoading, all_departments } = useSelector((state) => state?.vendor);
  const all_vendors = useSelector((state) => state?.vendor?.vendors);
  const vendor = all_vendors?.responseObject;

  // const { all_departments } = useSelector((state) => state?.vendor);
  // const all_departments = useSelector((state) => state?.vendor?.);
  // const vendor = all_vendors?.responseObject;

  // console.log("vender operations",  { all_vendors, isLoading, all_departments  });

  const { id } = useParams();

  const { openModal, closeModal } = useApprovals({});
  const [openSetUpModal, setOpenSetUpModal] = useState(false);

  const { stat } = findState(vendor?.registrationState);

  const Actions = () => {
    const hasSetUp = vendor?.managingDepartment?.length !== 0;

    const verifyUserApprovalLevel = () => {
      let userId = staffId;
      const PVM = vendor?.managingDepartment?.[0]?.id;
      const SVM = vendor?.managingDepartment?.[0]?.departmentUnit?.id;

      const fetchPVM = all_departments?.responseObject?.pageItems?.find(
        (x) => PVM === x?.id
      );

      const fetchSVM = fetchPVM?.containers?.find((x) => SVM === x?.id);

      const authorizedSVM = [
        // fetchSVM?.hocId, 5
        fetchSVM?.alternativeHOCId,
        5,
      ]?.includes(5);

      const authorizedPVM = [
        fetchPVM?.hodId,
        fetchPVM?.alternativeHODId,
      ]?.includes(userId);

      // if (isHod === false && isHeadOfUnit === false) {
      //   return {
      //     status: false,
      //   };
      // }

      return {
        status: true,
        authorizedPVM,
        authorizedSVM,
        // checkNextApproval: checkNextApproval(),
      };
    };

    verifyUserApprovalLevel();

    const values = [
      {
        name: "Setup Account",
        action: () => setOpenSetUpModal(!openSetUpModal),
        // condition: stat([STATUS.INITIATED, STATUS.DECLINED, STATUS.PROCESSING]),
      },
      {
        name: "Edit Details",
        condition: stat([STATUS.INITIATED, STATUS.DECLINED, STATUS.PROCESSING]),
        action: () => navigate(`../${id}/edit`, { state: vendor }),
        permissions: DEFINED_PERMISSIONS.VendorCreate,
      },
      {
        name: "Approve Account (SVM)",
        condition: stat([STATUS.SUSPENDED, STATUS.INITIATED, STATUS.DECLINED]),
        action: () => {
          openModal({
            type: "approve",
            details: {
              button: {
                name: "Yes, Approve",
                color: "",
              },
              isLoading: isLoading,
              sendIsOptional: false,
              commentIsOptional: true,
              title: "Approve Account",
              submitData: (data) => {
                dispatch(
                  ApproveVendorAction({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    designation: 0,
                  })
                )?.then((res) => {
                  closeModal();

                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: DEFINED_PERMISSIONS.SeniorVendorManager,
      },
      {
        name: "Approve Account (PVM)",
        condition: stat([STATUS.PROCESSING]),
        action: () => {
          openModal({
            type: "approve",
            details: {
              button: {
                name: "Yes, Approve",
                color: "",
              },
              isLoading: isLoading,
              sendIsOptional: false,
              commentIsOptional: true,
              title: "Approve Account",
              submitData: (data) => {
                dispatch(
                  ApproveVendorAction({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    designation: 1,
                  })
                )?.then((res) => {
                  closeModal();

                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: DEFINED_PERMISSIONS.PrimaryVendorManager,
      },
      {
        name: "Decline Account",
        condition: stat([STATUS.INITIATED, STATUS.PROCESSING]),
        action: () => {
          openModal({
            type: "decline",
            details: {
              button: {
                name: "Yes, Decline",
                color: "red",
              },
              commentIsOptional: true,
              sendIsOptional: true,
              title: "Decline Account",
              submitData: (data) => {
                dispatch(
                  DeclineVendorAction({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    isLoading: isLoading,
                  })
                )?.then((res) => {
                  closeModal();
                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: !userPermissions.includes(
          DEFINED_PERMISSIONS.SeniorVendorManager
        )
          ? DEFINED_PERMISSIONS.PrimaryVendorManager
          : DEFINED_PERMISSIONS.SeniorVendorManager,
      },
      {
        name: "Suspend Account",
        condition: stat([STATUS.APPROVED]),
        action: () => {
          openModal({
            type: "vendor_suspend",
            details: {
              button: {
                name: "Yes, Suspend",
                color: "red",
              },
              commentIsOptional: false,
              sendIsOptional: false,
              title: "Suspend Account",
              submitData: (data) => {
                dispatch(
                  SuspendVendorAction({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    isLoading: isLoading,
                    numOfDays: +data?.numOfDays,
                  })
                )?.then((res) => {
                  closeModal();

                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: DEFINED_PERMISSIONS.VendorManager,
      },
      {
        name: "Remove Suspension",
        condition: stat([STATUS.APPROVED, STATUS.SUSPENDED])
          ? true
          : // : vendor?.performance?.projectStartDate
            // ? true
            false,
        action: () => {
          openModal({
            type: "removesuspension",
            details: {
              button: {
                name: "Yes, Remove Suspension",
                color: "red",
              },
              commentIsOptional: false,
              sendIsOptional: false,
              title: "Remove Suspension",
              submitData: (data) => {
                dispatch(
                  SuspendVendorAction({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    isLoading: isLoading,
                    removeSuspension: true,
                  })
                )?.then((res) => {
                  closeModal();

                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: DEFINED_PERMISSIONS.VendorManager,
      },

      {
        name: "Blacklist Account",
        condition: stat([STATUS.APPROVED, STATUS.SUSPENDED])
          ? true
          : // : vendor?.performance?.projectStartDate
            // ? true
            false,
        action: () => {
          openModal({
            type: "blacklist",
            details: {
              button: {
                name: "Yes, Blacklist",
                color: "red",
              },
              commentIsOptional: true,
              sendIsOptional: true,
              title: "Blacklist Account",
              submitData: (data) => {
                dispatch(
                  BlackListVendor({
                    comment: data?.comments,
                    requestId: vendor?.requestId,
                    emailTrigger: data?.send,
                    isLoading: isLoading,
                  })
                )?.then((res) => {
                  closeModal();

                  if (res?.payload?.successful === true) {
                    dispatch(GetSingleVendor({ id }));
                  } else {
                    //setIsOpen(!isOpen);
                    toast.error(res?.payload?.statusMessage, {
                      autoClose: true,
                      style: { zIndex: 9999990 },
                    });
                  }
                });
              },
            },
          });
        },
        permissions: DEFINED_PERMISSIONS.VendorManager,
      },
      {
        name: "Appraise Vendor",
        condition: stat([STATUS.APPROVED, STATUS.SUSPENDED, STATUS.BLACKLISTED])
          ? true
          : false,
        action: () => navigate(`../${id}/appraise/0`, { state: vendor }),
        permissions: DEFINED_PERMISSIONS.PerformanceAdd,
      },
    ];

    if (hasSetUp === false) {
      const actions_for_vendors_without_setup = values.filter(
        (x) => x?.name === "Setup Account"
      );
      return actions_for_vendors_without_setup;
    }

    console.log({ values });
    return values;
  };

  return (
    <>
      <PageActions>{Actions()}</PageActions>
      <SetUpVendor
        openModal={openSetUpModal}
        setOpenModal={setOpenSetUpModal}
        vendor={vendor}
      />
    </>
  );
}

export default ViewVendorOperations;
